<div class="myPurchase-dialog-container">
    <div class="myPurchase-dialog-header">
        Assign alternative recommending officer </div>
    <div class="myPurchase-dialog-content">
        <mat-form [formGroup]="formGroup">
            <div *ngFor="let item of data.officerSelection">
                <div>Under your {{item.workflowName}} workflow, {{ getNameOfUser(item.originalDRO)}} is both the
                    recommending and
                    approving officer. Please deconflict and assign an alternative recommending officer. This action
                    cannot be undone.</div>
                <div style="padding-top: 10px;">
                    <mat-label>Reccommending Officer *</mat-label><br />
                    <mat-form-field style="width:100%">
                        <mat-select [formControlName]="item.originalDRO" required="true">
                            <mat-option *ngFor="let alternative of item.alternativeDROs" [value]='alternative'>{{
                                getNameOfUser(alternative)}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </mat-form>
    </div>
    <div class="myPurchase-dialog-actions">
        <div mat-dialog-actions>
            <app-button class="padBtn" name="Close" mat-dialog-close></app-button>
            <app-button class="padBtn actionBtn" type="flat-button" name="Submit" (click)="onSubmit()"></app-button>
        </div>
    </div>
</div>